import { SettingConfigInput, SettingsProps } from "./SettingConfigInput";

export type GeneralConfigsProps = {
    id: number;
    key: string;
    name: string;
    settings: SettingsProps[];
};

const PAYMENT_SETTING_KEYS = new Set(["invoice_payment_methods"]);

function splitSettings(settings: SettingsProps[]) {
    const mainSettings: SettingsProps[] = [];
    const paymentSettings: SettingsProps[] = [];

    settings.forEach((setting) => {
        if (PAYMENT_SETTING_KEYS.has(setting.key)) {
            paymentSettings.push(setting);
            return;
        }

        mainSettings.push(setting);
    });

    return { mainSettings, paymentSettings };
}

export function SettingConfigSection({
    config,
    handleChangeInputs,
}: {
    config: GeneralConfigsProps;
    handleChangeInputs: (key: string, value: any) => void;
}) {
    const { mainSettings, paymentSettings } = splitSettings(config.settings);

    return (
        <div className="settings-section">
            <h3>{config.name}</h3>

            <div className="settings-block">
                {mainSettings.map((setting) => (
                    <SettingConfigInput
                        key={setting.id}
                        setting={setting}
                        handleChangeInputs={handleChangeInputs}
                    />
                ))}
            </div>

            {paymentSettings.length > 0 ? (
                <div className="settings-block settings-block--separated">
                    <h4>Pagamento de faturas</h4>
                    {paymentSettings.map((setting) => (
                        <SettingConfigInput
                            key={setting.id}
                            setting={setting}
                            handleChangeInputs={handleChangeInputs}
                        />
                    ))}
                </div>
            ) : null}
        </div>
    );
}
